export const ROL = {
  SUPERADMIN: 1,
  ADMIN: 2,
  COWORKER: 3
}

/*LOGIN*/
export const CODE_MULTI_FACTOR_AUTH = "AADSTS50076"
export const CODE_AUTH_EXPIRED = "AADSTS70008"
export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000

/* SUPPORTED LANGUAGES */
export const SUPPORTED_LANGUAGES = ['en', 'es', 'jp']
